var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEr = function SvgEr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e124250-a76b-4eff-8033-da38413eb09ea)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9e763663-dc68-4df0-a1c8-15b15cd181bdb",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#9e763663-dc68-4df0-a1c8-15b15cd181bdb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3C87E0",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AF1E",
    fillRule: "evenodd",
    d: "M0 0h21v8H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED0030",
    fillRule: "evenodd",
    d: "m0 0 21 7.5L0 15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC800",
    fillRule: "evenodd",
    d: "M9 7.5c0-1.38-1.12-2.5-2.5-3C5.12 5 4 6.12 4 7.5c0 1.21.86 2.218 2 2.45V6.498C6 6.223 6.232 6 6.5 6c.276 0 .5.215.5.498V9.95c1.14-.232 2-1.24 2-2.45m1 0c0-1.933-1.567-3.5-3.5-3C4.567 4 3 5.567 3 7.5a3.5 3.5 0 1 0 7 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19 .5H2A1.5 1.5 0 0 0 .5 2v11A1.5 1.5 0 0 0 2 14.5h17a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 19 .5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5e124250-a76b-4eff-8033-da38413eb09ea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h21v15H0z"
  })))));
};
export default SvgEr;